import React from 'react'
import { Handle, Position } from '@xyflow/react';

const initStyle = {
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: '#4A90D9',
    border: '2px solid #fff',
    boxShadow: '0 0 0 1px #4A90D9',
    transition: 'all 0.2s ease',
}

function TargetHandle({ id }) {
    return <Handle key={id} id={id} type="target" position={Position.Left} style={initStyle} />
}

export default React.memo(TargetHandle)
